import React, { Component } from "react";
import { matchesString, matchesBoolean } from "LIB/filters";
import {
  FilterSelect,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Search } from "MODULES/shared/components";
import { parse } from "query-string";
import api from "APP_ROOT/api";
import CurrentPurchasesTable from "./CurrentPurchasesTable";
import BuyerReportTable from "./BuyerReportTable";
import pagination from "../../pagination";

const filters = [
  {
    label: "Show Today",
    filters: { period: "day" }
  },
  {
    label: "Show This Week",
    filters: { period: "week" }
  },
  {
    label: "Show This Month",
    filters: { period: "month" }
  },
  {
    label: "Show This Quarter",
    filters: { period: "quarter" }
  },
  {
    label: "Show This Year",
    filters: { period: "year" }
  },
  {
    label: "Show Last Year",
    filters: { period: "last_year" }
  }
];

const filterTags = [
  {
    label: "Today",
    key: "period",
    matchesTarget: matchesString("day")
  },
  {
    label: "Today",
    key: "period",
    matchesTarget: matchesString(undefined)
  },
  {
    label: "This Week",
    key: "period",
    matchesTarget: matchesString("week")
  },
  {
    label: "This Month",
    key: "period",
    matchesTarget: matchesString("month")
  },
  {
    label: "This Quarter",
    key: "period",
    matchesTarget: matchesString("quarter")
  },
  {
    label: "This Year",
    key: "period",
    matchesTarget: matchesString("year")
  },
  {
    label: "Last Year",
    key: "period",
    matchesTarget: matchesString("last_year")
  }
];

export default class PurchasesReport extends Component {
  constructor(props) {
    super(props);
    api.users
      .search({
        yearly_buyers: true,
        page: 1,
        sort: "first_name",
        reverse: false,
        limit: 1000
      })
      .then(resp => {
        const buyers = resp.data.results;
        const buyersOptions = buyers.map(b => ({
          label: b.full_name,
          filters: { buyer_id: b.id, report_type: "single" }
        }));
        const buyersTags = buyers
          .map(b => ({
            label: b.full_name,
            key: "buyer_id",
            matchesTarget: matchesBoolean(b.id)
          }))
          .concat([
            {
              label: "Everyone Combined",
              key: "buyer_id",
              matchesTarget: matchesString("all")
            }
          ]);

        this.state = {
          buyersFilter: [
            {
              label: "View All",
              filters: { buyer_id: undefined, report_type: "single" }
            }
          ]
            .concat(buyersOptions)
            .concat([
              {
                label: "Everyone Combined",
                filters: { buyer_id: "all", report_type: "all" }
              }
            ]),
          buyersTags
        };
      });
  }

  state = {
    buyersFilter: [],
    buyersTags: []
  };

  render() {
    return (
      <Search search={pagination} syncWithUrl>
        {searchProps => {
          const buyerId = parse(location.search).buyer_id;
          let title = "Purchase Credit by Buyer";
          if (buyerId) {
            title = `Purchasing Report Card`;
          }
          return (
            <div>
              <div className="form-group form-group-searchbar">
                <div
                  className="input-group buyer-stats-filters"
                  style={{ width: "240px" }}
                >
                  <FilterSelect
                    {...searchProps}
                    title="Period"
                    filters={filters}
                  />
                  <FilterSelect
                    {...searchProps}
                    title="Buyer"
                    filters={this.state.buyersFilter}
                  />
                </div>
              </div>
              <TitleWithFilters
                {...searchProps}
                title={title}
                filters={filterTags.concat(this.state.buyersTags)}
              />
              {buyerId !== undefined ? (
                <BuyerReportTable {...searchProps} />
              ) : (
                <CurrentPurchasesTable {...searchProps} />
              )}
            </div>
          );
        }}
      </Search>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/PurchasesReport/Components/Search/Search.jsx